/**
 * Alluvion Home — Personalised Drinks Print: Frame Swatches + Steps
 * ==================================================================
 * Separate copy for the drinks print only, so the address print and
 * Print Your Own stay untouched. Runs only where window.ALV_DRINKS exists,
 * which theme.liquid sets on the personalised-drinks-print template.
 *
 * Adds the step 4 heading (size and frame) and shows 5 frame swatches
 * instead of Dawn's Style control. Your variants stay
 * exactly as they are: this script picks the matching Style value in Dawn's
 * own control (which it hides), so Dawn updates the price, variant and URL
 * as normal, and the live preview follows.
 *
 * Swatch images come from window.ALV_SWATCHES (set in theme.liquid).
 */

(function () {
  'use strict';

  if (!window.ALV_DRINKS) return;

  var CFG = {
    option: 'Style',
    step:   { number: 4, text: 'Choose your size and frame' },
    labels: { size: 'Size', frame: 'Frame' }
  };

  var OPTION = CFG.option;

  var FRAMES = [
    { value: 'Print Only',      label: 'Print only', color: '#ffffff' },
    { value: 'Black Frame',     label: 'Black',      color: '#1c1c1c' },
    { value: 'White Frame',     label: 'White',      color: '#f4f3ef' },
    { value: 'Light Oak Frame', label: 'Light oak',  color: '#cfa874' },
    { value: 'Dark Oak Frame',  label: 'Dark oak',   color: '#5e3d27' }
  ];

  var state = { frame: 'Print Only' };
  var ui = {};

  function init() {
    var current = getDawnValue();
    if (!current) {
      console.warn('[Alluvion Drinks Frames] Style option not found — leaving Dawn\'s picker visible');
      return;
    }
    state.frame = current;
    injectStyles();
    buildUi();
    addSteps();
    hideDawnControl();
    watchDawn();
    document.addEventListener('change', onAnyChange);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* ── Dawn's Style control ────────────────────────────────────────── */
  function scope() { return document.querySelector('variant-selects, variant-radios') || document; }

  function findSelect(name) {
    var list = scope().querySelectorAll('select');
    for (var i = 0; i < list.length; i++) if ((list[i].name || '').indexOf(name) !== -1) return list[i];
    return null;
  }

  function findRadios(name) {
    return Array.prototype.filter.call(
      scope().querySelectorAll('input[type="radio"]'),
      function (r) { return (r.name || '').indexOf(name) !== -1; }
    );
  }

  function getDawnValue() {
    var s = findSelect(OPTION);
    if (s) return s.value;
    var radios = findRadios(OPTION);
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i].value;
    return null;
  }

  function setDawnValue(value) {
    var s = findSelect(OPTION);
    if (s) {
      if (s.value === value) return;
      var exists = Array.prototype.some.call(s.options, function (o) { return o.value === value; });
      if (!exists) { console.warn('[Alluvion Drinks Frames] No Style value "' + value + '"'); return; }
      s.value = value;
      s.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var radios = findRadios(OPTION);
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) { if (!radios[i].checked) radios[i].click(); return; }
    }
    console.warn('[Alluvion Drinks Frames] No Style value "' + value + '"');
  }

  function hideDawnControl() {
    var el = findSelect(OPTION) || findRadios(OPTION)[0];
    var wrap = el && el.closest('.product-form__input');
    if (wrap) wrap.classList.add('alv-fp-hidden');
  }

  /* Newer Dawn versions rebuild the variant picker after each change */
  function watchDawn() {
    var vs = document.querySelector('variant-selects, variant-radios');
    if (vs && vs.parentNode && window.MutationObserver) {
      new MutationObserver(hideDawnControl).observe(vs.parentNode, { childList: true });
    }
  }

  function onAnyChange(e) {
    var el = e.target;
    if (!el || !el.name || (ui.root && ui.root.contains(el))) return;
    if (el.name.indexOf(OPTION) !== -1) { state.frame = el.value; update(); }
  }

  /* ── Numbered steps ──────────────────────────────────────────────── */
  function stepHtml(n, text) {
    return '<span class="alv-step__num" aria-hidden="true">' + n + '</span>' +
           '<span class="alv-step__text">' + text + '</span>';
  }

  /* Step 4 heading above Dawn's size dropdown, with a small "Size" label under it */
  function addSteps() {
    var vs = document.querySelector('variant-selects, variant-radios');
    if (vs && !document.getElementById('alv-step-size')) {
      var h = document.createElement('p');
      h.id = 'alv-step-size';
      h.className = 'alv-step';
      h.innerHTML = stepHtml(CFG.step.number, CFG.step.text);
      vs.parentNode.insertBefore(h, vs);
      var l = document.createElement('p');
      l.className = 'alv-sublabel';
      l.textContent = CFG.labels.size;
      vs.parentNode.insertBefore(l, vs);
    }
  }

  /* ── UI ───────────────────────────────────────────────────────────── */
  function buildUi() {
    var images = window.ALV_SWATCHES || {};
    var root = document.createElement('div');
    root.className = 'alv-fp';
    root.id = 'alv-frame-picker';

    var html =
      '<p class="alv-sublabel alv-fp__legend" id="alv-fp-legend">' + CFG.labels.frame +
        '<span class="alv-fp__current"></span></p>' +
      '<div class="alv-fp__swatches" role="radiogroup" aria-labelledby="alv-fp-legend">';
    FRAMES.forEach(function (f) {
      html +=
        '<button type="button" class="alv-fp__swatch" role="radio" aria-checked="false" data-frame="' + f.value + '">' +
          '<span class="alv-fp__chip" data-frame-chip="' + f.value + '"></span>' +
          '<span class="alv-fp__name">' + f.label + '</span>' +
        '</button>';
    });
    html += '</div>';
    root.innerHTML = html;

    FRAMES.forEach(function (f) {
      var chip = root.querySelector('[data-frame-chip="' + f.value + '"]');
      chip.style.backgroundColor = f.color;
      if (images[f.value]) chip.style.backgroundImage = 'url("' + images[f.value] + '")';
    });

    root.querySelector('.alv-fp__swatches').addEventListener('click', function (e) {
      var btn = e.target.closest('.alv-fp__swatch');
      if (!btn) return;
      state.frame = btn.getAttribute('data-frame');
      setDawnValue(state.frame);
      update();
    });

    /* After Dawn's variant picker (outside it, so Dawn's re-renders don't remove it) */
    var vs = document.querySelector('variant-selects, variant-radios');
    var anchor = vs || (findSelect(OPTION) || findRadios(OPTION)[0]).closest('.product-form__input');
    anchor.parentNode.insertBefore(root, anchor.nextSibling);

    ui.root     = root;
    ui.current  = root.querySelector('.alv-fp__current');
    ui.swatches = root.querySelectorAll('.alv-fp__swatch');
  }

  function update() {
    if (!ui.root) return;
    var label = state.frame;
    Array.prototype.forEach.call(ui.swatches, function (b) {
      var on = b.getAttribute('data-frame') === state.frame;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      if (on) label = b.querySelector('.alv-fp__name').textContent;
    });
    ui.current.textContent = label;
  }

  /* ── Styles ──────────────────────────────────────────────────────── */
  function injectStyles() {
    if (document.getElementById('alv-fp-styles')) return;
    var style = document.createElement('style');
    style.id = 'alv-fp-styles';
    style.textContent = [
      '.alv-fp-hidden,',
      'variant-selects .product-form__input:has(select[name*="' + OPTION + '"]),',
      'variant-selects .product-form__input:has(input[type="radio"][name*="' + OPTION + '"]) { display: none !important; }',
      'variant-selects .product-form__input:has(select[name*="Size"]) .form__label,',
      'variant-selects .product-form__input:has(input[type="radio"][name*="Size"]) > legend { position: absolute !important; width: 1px; height: 1px; margin: -1px; padding: 0; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; border: 0; }',
      '.alv-step { display: flex; align-items: center; gap: 1rem; margin: 0 0 1rem; font-size: 1.5rem; line-height: 1.3; color: rgb(var(--color-foreground)); }',
      '.alv-step__num { flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center; width: 2.4rem; height: 2.4rem; border-radius: 50%; background: rgb(var(--color-foreground)); color: rgb(var(--color-background)); font-size: 1.2rem; font-weight: 600; line-height: 1; }',
      '.alv-sublabel { display: flex; margin: 0 0 .6rem; font-size: 1.3rem; line-height: 1.3; color: rgb(var(--color-foreground)); }',
      '.alv-fp { margin: 0 0 2rem; }',
      '.alv-fp__legend { margin-top: 1.4rem; }',
      '.alv-fp__current { margin-left: auto; padding-left: .8rem; font-size: 1.3rem; text-align: right; color: rgba(var(--color-foreground), .65); }',
      '.alv-fp__swatches { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: .8rem; }',
      '.alv-fp__swatch { display: flex; flex-direction: column; align-items: center; gap: .6rem; padding: .6rem .6rem .8rem; border: 1px solid rgba(var(--color-foreground), .15); border-radius: var(--inputs-radius, 4px); background: none; color: inherit; font: inherit; cursor: pointer; transition: border-color .15s, box-shadow .15s; }',
      '.alv-fp__swatch:hover { border-color: rgba(var(--color-foreground), .45); }',
      '.alv-fp__swatch[aria-checked="true"] { border-color: rgb(var(--color-foreground)); box-shadow: 0 0 0 1px rgb(var(--color-foreground)); }',
      '.alv-fp__swatch:focus-visible { outline: 2px solid rgb(var(--color-foreground)); outline-offset: 2px; }',
      '.alv-fp__chip { display: block; width: 100%; aspect-ratio: 1; border-radius: 2px; background-size: cover; background-position: center; box-shadow: inset 0 0 0 1px rgba(0,0,0,.08); }',
      '.alv-fp__name { font-size: 1.15rem; line-height: 1.2; text-align: center; }',
      '@media (max-width: 400px) { .alv-fp__swatches { gap: .5rem; } .alv-fp__name { font-size: 1.05rem; } }'
    ].join('\n');
    document.head.appendChild(style);
  }

})();